import { CheckCircleIcon, InfoIcon } from "@phosphor-icons/react";
import { Flex, Typography, Tooltip } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { useTranslate } from "@refinedev/core";
import {
  SIDER_WIDTH,
  SIDER_COLLAPSED_WIDTH,
} from "components/layout/sider/styles";
import { useBoundStore } from "store";

export const ComplianceFooter = () => {
  const { theme, isMobile } = useAntTheme();
  const t = useTranslate();
  const collapsed = useBoundStore((state) => state.sidebarCollapsed);
  const sidebarHovered = useBoundStore((state) => state.sidebarHovered);

  let width: string;
  let marginLeft = 0;
  let left: number | string;

  if (isMobile) {
    width = `100%`;
    marginLeft = 0;
    left = 0;
  } else if (sidebarHovered || collapsed) {
    width = `calc(100% - ${SIDER_COLLAPSED_WIDTH}px)`;
    left = SIDER_COLLAPSED_WIDTH + "px";
  } else {
    width = `calc(100% - ${SIDER_WIDTH}px)`;
    left = SIDER_WIDTH + "px";
  }

  const messages = [
    {
      title: t("projects.components.Footer.certified"),
      comment: t("projects.components.Footer.securityFrameworks"),
    },
    {
      title: t("projects.components.Footer.GDPRCompliant"),
      comment: t("projects.components.Footer.privacyMatters"),
    },
    {
      title: t("projects.components.Footer.AIEthics"),
      comment: t("projects.components.Footer.ourAI"),
    },
  ];
  return (
    <Flex
      align="center"
      justify="space-between"
      vertical={isMobile}
      gap={5}
      style={{
        textAlign: "center",
        position: "fixed",
        bottom: 0,
        width,
        marginLeft,
        paddingRight: theme.paddingLG,
        paddingLeft: theme.paddingLG,
        paddingTop: theme.paddingSM,
        paddingBottom: theme.paddingSM,
        left,
        backgroundColor: theme.colorPrimary,
        opacity: 0.85,
      }}
    >
      {messages.map((message) => {
        return (
          <Flex key={message.title} gap={4} align="center">
            <CheckCircleIcon size={16} color={theme.colorBgElevated} />
            <Typography.Text
              style={{ color: theme.colorBgElevated, fontSize: 13 }}
            >
              {message.title}
            </Typography.Text>
            <Tooltip title={message.comment}>
              <InfoIcon
                size={14}
                style={{ marginTop: -10 }}
                color={theme.colorBgElevated}
              />
            </Tooltip>
          </Flex>
        );
      })}
    </Flex>
  );
};
